<script>
    import * as animateScroll from "svelte-scrollto";
    import watchMedia from "svelte-media";
    import MediaQuery from "svelte-media-query";

    const walletImg = 'assets/walletImg.svg';
    const pcImg = 'assets/pcImg.svg';
    const check = 'assets/check.svg';

    const bank = 'assets/productFeatures/bank.svg';
    const wallet = 'assets/productFeatures/wallet.svg';
    const card = 'assets/productFeatures/card.svg';
    const business = 'assets/productFeatures/business.svg';
    const tradingDesk = 'assets/productFeatures/tradingDesk.svg';
    const other = 'assets/productFeatures/others.svg';

    const mediaqueries = {
        small: "(max-width: 769px)",
    };
    export const media = watchMedia(mediaqueries);

    const gridData = [
        { img: bank, header: 'Bank accounts', description: [ { desk: 'Order IBANs from EU banks' } ] },
        { img: wallet, header: 'Crypto wallet', description: [ { desk: 'Receive and send BTC & ETH' } ] },
        { img: card, header: 'Cards', description: [ { desk: 'Order limited and unlimited debit cards' }, { desk: 'Full control of your cards (ordering, activation, pin codes, limits) ' },{ desk: 'Top-up your wallet with credit/debit card or wire', } ] },
        { img: business, header: 'Business account', description: [ { desk: 'Get your business financial in to our platform and make it even easier to manage, receive more option of payments and give more to your clients.' } ] },
        { img: tradingDesk, header: 'Trading desk', description: [ { desk: 'Exchange currencies; USD, EUR, BTC, ETH' } ] },
        { img: other, header: 'Others', description: [ { desk: 'Transfer and withdraw your assets inside and out of the system to any other financial institution within a click of a button.' }, { desk: 'Controlling all your transaction history with details.'  }, { desk: 'Fast and free transactions to other users only with ID user or email.', } ] },
    ];

    const displayData = {
        all: gridData,
        part: gridData.filter((_, i) => i < 3)
    }

    let showMore = false;
    let gridDataToShow = $media.small ? displayData.part : displayData.all
 
    const handleShowMoreFeatures = () => {
        if(!showMore){
            gridDataToShow = displayData.all
            showMore = !showMore
        }else{
            gridDataToShow = displayData.part
            showMore = !showMore
            animateScroll.scrollTo({element: '.productsGrid'});
        }
    }

</script>

<div class="container" id='features'>
    <div class="productFeaturesContainer">
        <div class="productFeatures">
            <div class="productFeaturesHeader">
                Product features
            </div>
            <div class='offers'>
                <div class="productFeaturesDescriptiom">
                    <div class="dot">•</div>
                    <img class="descriptionImg" src={walletImg} alt='logo'/>
                    <div class="descriptionText">
                        <div class="descriptionHeader"> We offer </div>
                        <div> All in one wallet with limitless abilities </div>
                    </div>
                </div>
                <div class='line'></div>
                <div class="productFeaturesDescriptiom">
                    <div class="dot">•</div>
                    <img class="descriptionImg" src={pcImg} alt='logo'/>
                    <div class="descriptionText">
                        <div class="descriptionHeader"> You get </div>
                        <div> Access to enhanced online platform to control and manage your assets </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="productFeaturesContainer">
        <div class="productsGrid">
             {#each gridDataToShow as gridVal}
                <div class="productsGridCol">
                    <img class="productsGridColImg" src={gridVal.img} alt='logo'/> 
                    <div class="productsGridColHeader"> {gridVal.header}</div>
                    <div class="productsGridColDescription">
                        {#each gridVal.description as description }
                            <div class='productDescriptionSentence'>
                                <div class='check' ><img src={check} alt='check'/></div>
                                <div> {description.desk} </div> 
                            </div>
                        {/each}
                    </div>
                </div>
             {/each}
        </div>
        <MediaQuery query="(max-width: 769px)" let:matches>
            {#if matches}
                <div class='viewAllProductsButton' on:click={handleShowMoreFeatures}>{!showMore ? 'View all' : 'View less'}</div>
            {/if}
        </MediaQuery>
    </div>
</div>


<style>

    .container{
        margin-top: 100px;
        padding: 50px 30px;
        background: linear-gradient(180deg, #F6F6F6 0%, #FFFFFF 100%);
     }

     .offers{
         position: relative;
     }

     .line{
        border-left: 1px solid #dddddd;
        height: 53px;
        margin-left: 7px;
        position: absolute;
        top: 47px;
     }

     .productFeaturesContainer{
        max-width: 1170px;
        margin: 0 auto;
     }

    .productFeatures{
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
    }

    .productFeaturesHeader{
        color: #3A3A3C;
        font-size: 32px;
        letter-spacing: -1px;
        line-height: 36px;
    }

    .productFeaturesDescriptiom{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .descriptionImg{
        margin: 0 20px;
    }

    .descriptionHeader{
        font-size: 20px;
        line-height: 26px;
        text-align: left;
        margin-bottom: 10px;
        font-weight: 600;
    }

    .productsGrid{
        margin-top: 100px;
        display: flex;
        grid-gap: 20px;
        flex-wrap: wrap;
    }

    .productsGridCol{
        flex: 30%;
        padding-top: 40px;
        border-top: 2px solid #dddddd;
    }

    .productsGridColImg{
        width: 64px;
        height: 68px;
        object-fit: none;
    }

    .productsGridColHeader{
        font-size: 20px;
        line-height: 26px;
        font-weight: 600;
        margin: 10px 0;
    }

    .productDescriptionSentence{
        display: flex;
        margin-bottom: 10px;
        color: #666666;

    }

    .check{
        margin-right: 10px;
    }

    .viewAllProductsButton{
        border: 2px solid #DDDDDD;
        border-radius: 4px;
        width: 250px;
        height: 46px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        margin: 0 auto;
        margin-top: 50px;
    }

    .dot{
        font-size: 50px;
        color: #878E9F;
    }

    @media (max-width: 769px) { 

        .container{
            margin-top: 50px;
            padding: 20px 30px;
        }

        .productFeatures{
            flex-direction: column;
            align-items: center;
            padding-top: 0;
        }

        .productFeaturesHeader {
            font-size: 32px;
            margin-bottom: 40px;
        }

        
        .productsGrid{
            margin-top: 50px;
            display: flex;
            flex-direction: column;
        }

    }

</style>